/*
 *
 * ----------------------------------------------- */
// var $eScroll = jQuery(".text-animation");
// var eOffset = $eScroll.offset();

// jQuery(window).on("load scroll", function () {
//   if (!$eScroll.length) {
//     return false;
//   }

//   var st = jQuery(this).scrollTop();
//   $eScroll.css("left", eOffset.left + eOffset.top - $eScroll.width() - st);
// });
